import styled, { css } from 'styled-components';
import { rem } from 'polished';

const WrapperRadio = styled.div`
  display: flex;
  position: relative;
`;

const StyledRadio = styled.input.attrs({
  type: 'radio'
})`
  cursor: pointer;
  height: 100%;
  left: 0;
  margin: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
`;

const StyledLabel = styled.label`
  padding-left: 0.5rem;
  line-height: 1rem;
  ${props =>
    props.checked &&
    css`
      font-family: ${props.theme.fonts.bold};
    `};
  ${props =>
    props.disabled &&
    css`
      color: ${props.theme.colors.grayDark};
    `};
`;

const StyledCheckable = styled.div`
  background: ${props => props.theme.colors.light};
  border-radius: 100%;
  border: 1px solid ${props => props.theme.colors.grayDarker};
  cursor: pointer;
  display: inline-block;
  height: ${rem('16px')};
  position: relative;
  width: ${rem('16px')};
  &:hover,
  &:focus {
    box-shadow: 0 1px 2px 0 ${props => props.theme.colors.main};
  }
  ${props =>
    props.checked &&
    css`
      border: 1px solid ${props.theme.colors.success};
      box-shadow: 0 1px 2px 0 ${props.theme.colors.main};
      &:before {
        content: '';
        background-color: ${props.disabled
          ? props.theme.colors.gray
          : props.theme.colors.success};
        border-radius: 50%;
        height: 10px;
        left: 2px;
        position: absolute;
        top: 2px;
        width: 10px;
      }
    `};
  ${props =>
    props.disabled &&
    css`
      border: 1px solid ${props.theme.colors.gray};
      box-shadow: 0 1px 2px 0 ${props.theme.colors.gray};
    `};
`;

export { WrapperRadio, StyledRadio, StyledLabel, StyledCheckable };
